// extracted by mini-css-extract-plugin
export var tabHeadingItem = "schema-tab-section-component-module--tabHeadingItem--249ef";